import {
  VISTA_VENDEDOR_MARK_CATALOG_FORCE_REFRESH,
  VISTA_VENDEDOR_CLEAR_CATALOG_FORCE_REFRESH,
} from './constants'

export function markCatalogForRefresh() {
  return {
    type: VISTA_VENDEDOR_MARK_CATALOG_FORCE_REFRESH,
  }
}

export function clearCatalogForceRefresh() {
  return {
    type: VISTA_VENDEDOR_CLEAR_CATALOG_FORCE_REFRESH,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case VISTA_VENDEDOR_MARK_CATALOG_FORCE_REFRESH:
      return {
        ...state,
        forceCatalogRefresh: true,
      }
    case VISTA_VENDEDOR_CLEAR_CATALOG_FORCE_REFRESH:
      return {
        ...state,
        forceCatalogRefresh: false,
      }
    default:
      return state
  }
}
